var _path, _path2, _path3, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7764 0C10.7823 5.32167 10.6969 5.96983 11.0068 6.14941C11.3048 6.32292 11.2554 6.26277 13.8262 4.72754L16.2051 6.14062C16.5002 6.31708 16.8718 6.10183 16.8721 5.75488V0.00292969H19.9688V10.7529H17.6631V10.75C17.6631 9.47759 16.6317 8.44558 15.3594 8.44531C14.0868 8.44531 13.0547 9.47743 13.0547 10.75V10.7529H7.67969V0H10.7764Z",
    fill: "#F94E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6285 3.56339C13.8959 3.39974 13.909 3.48975 15.7466 4.61076V0.0078125L11.9062 0.0132676L11.9115 4.61621L13.6285 3.56339Z",
    fill: "#F94E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52832 9.21777H8.06445V10.7539H6.14746C6.14562 9.48307 5.11496 8.45339 3.84375 8.45312C2.57232 8.45312 1.54091 9.4829 1.53906 10.7539H0V9.21777H0.768555V5.37695L3.07227 2.30469H6.52832V9.21777ZM2.30469 5.37988H5.37695V3.84375H3.45703L2.30469 5.37988Z",
    fill: "#1B6AE3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.84082,
    cy: 10.7549,
    r: 1.53613,
    fill: "#365550"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3643,
    cy: 10.7549,
    r: 1.53613,
    fill: "#365550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.f53081f9c18497b6ff03e1f9d683dd08.svg";
export { ForwardRef as ReactComponent };